import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import Const from '../../config/const';
import PanelLayout from '../panel/layout';
import * as shared from '../assets/shared.module.scss';

export default class CustomPreviewPanel extends PureComponent {
  static propTypes = {
    custom: PropTypes.bool.isRequired,
    automaticPreview: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired
    }).isRequired,

    closePanel: PropTypes.func.isRequired,
    setCrop: PropTypes.func.isRequired,
    resetCrop: PropTypes.func.isRequired
  };

  closePanel = () => {
    const { closePanel } = this.props;
    closePanel(Const.panelKinds.customPreview);
  };

  onToggleCrop = (e, { checked }) => {
    const {
      automaticPreview: {
        x, y, width, height
      },
      setCrop,
      resetCrop
    } = this.props;

    if (checked) {
      setCrop({
        x, y, width, height
      });
      return;
    }
    resetCrop();
  };

  render() {
    const { custom } = this.props;

    return (
      <PanelLayout
        onClose={ this.closePanel }
        title="Custom Crop"
      >
        <div className={ shared.container }>
          <div className={ shared.scroll }>
            <Checkbox
              checked={ !!custom }
              label="Use Custom Crop"
              onChange={ this.onToggleCrop }
            />
          </div>
        </div>
      </PanelLayout>
    );
  }
}
